import React from "react";
import "./CustomersGrid.css";

const customers = [
  { name: "Singapore Refining Company", logo: "/img/customers/singapore-refining.jpeg" },
  { name: "ExxonMobil", logo: "/img/customers/exxonmobil.jpeg" },
  { name: "REC", logo: "/img/customers/recnew.jpeg" },
  { name: "Liebherr", logo: "/img/customers/liebherrnew.jpeg" },
  { name: "ST Aerospace", logo: "/img/customers/staerospace.jpeg" },
  { name: "Thermofisher", logo: "/img/customers/thermofishernew.jpeg" },
  { name: "PharmaGend", logo: "/img/customers/pharmagen.jpeg" },
  { name: "CBRE", logo: "/img/customers/cbre.jpeg" },
  { name: "Barnes Aerospace", logo: "/img/customers/barnes-aerospace.jpeg" },
];

const CustomersGrid = () => {
  return (
    <div className="customers-section">
      <div className="section-title text-center">
        <h2>Our Valuable Customers</h2>
      </div>

      <div className="customers-grid">
        {customers.map((customer, index) => (
          <div key={index} className="customer-card">
            <div className="logo-wrapper">
              <img src={customer.logo} alt={customer.name} />
            </div>
            <p className="customer-name">{customer.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomersGrid;

